<template>
  <div class="as-data">
    <ul class="as-nav-tabs">
      <li class="as-nav-item" v-for="tab in tabs" :key="tab.key">
        <a
          class="as-nav-link"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
        >
          {{ tab.title }}
        </a>
      </li>
    </ul>

    <div class="as-h2h as-scrolling as-scrolling__result-popup">
      <TabData v-if="activeTab === 'data'" :match="match" />
      <TabRateScore v-else-if="activeTab === 'rate_score'" :match="match" :data="data" />
      <TabStatsHtFt v-else-if="activeTab === 'stats_ht_ft'" :match="match" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type { IMatch, IAnalysis } from "~src/interfaces";
import TabData from "~src/components/datas/TabData.vue";
import TabRateScore from "~src/components/datas/TabRateScore.vue";
import TabStatsHtFt from "~src/components/datas/TabStatsHtFt.vue";

interface IProps {
  match: IMatch;
  data: IAnalysis;
}

const props = withDefaults(defineProps<IProps>(), {});

const activeTab = ref("data");
const tabs = ref([
  {
    title: "DỮ LIỆU",
    key: "data",
  },
  {
    title: "tỷ lệ ghi/mất bàn thắng",
    key: "rate_score",
  },
  {
    title: "thống kê ht/ft",
    key: "stats_ht_ft",
  },
]);
</script>

<script lang="ts">
export default {};
</script>
